export enum FeatureFlagName {
  STONLY_KB = 'STONLY_KB',
  VONAGE_WHATSAPP_SERVICE = 'VONAGE_WHATSAPP_SERVICE',
  ENGAGE_ATTACHMENT = 'ENGAGE_ATTACHMENT',
  AI_AGENT_PRODUCTIVITY = 'AI_AGENT_PRODUCTIVITY',
  KEYCLOAK_AUTHENTICATION_DELEGATION = 'KEYCLOAK_AUTHENTICATION_DELEGATION',
  CREDIT_CARD_SANITIZATION = 'CREDIT_CARD_SANITIZATION',
  COMPANY_RECORD = 'COMPANY_RECORD',
  EXTERNAL_REFERENTIAL_CUSTOMER_MS = 'EXTERNAL_REFERENTIAL_CUSTOMER_MS',
  MICROSOFT_CLARITY = 'MICROSOFT_CLARITY',
  SMS_OUTBOX = 'SMS_OUTBOX',
  NEW_MAIL_MANAGMENT = 'NEW_MAIL_MANAGMENT',
}
